import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { AdminTitle } from "@/pages/admin/AdminUI";

export default function AdminCustomers() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/customers").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (items === null) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-amber-400" size={36} /></div>;
  return (
    <div>
      <AdminTitle title={`Customers (${items.length})`} />
      <div className="card-lux overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="admin-customers-table">
            <thead className="bg-black/30 text-slate-500 text-xs uppercase"><tr><th className="text-left px-5 py-3">Name</th><th className="text-left px-5 py-3">Email</th><th className="text-left px-5 py-3">Country</th><th className="text-left px-5 py-3">Phone</th><th className="text-left px-5 py-3">Verified</th><th className="text-left px-5 py-3">Joined</th></tr></thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="border-t border-white/5" data-testid={`customer-row-${c.id}`}>
                  <td className="px-5 py-3 text-white">{c.name}</td>
                  <td className="px-5 py-3 text-slate-400">{c.email}</td>
                  <td className="px-5 py-3 text-slate-400">{c.country || "—"}</td>
                  <td className="px-5 py-3 text-slate-400">{c.phone || "—"}</td>
                  <td className="px-5 py-3">{c.email_verified ? <span className="text-emerald-400 text-xs">Yes</span> : <span className="text-slate-500 text-xs">No</span>}</td>
                  <td className="px-5 py-3 text-slate-500 text-xs">{(c.created_at || "").slice(0, 10)}</td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={6} className="px-5 py-10 text-center text-slate-500">No customers yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
